import { getSpaceByTheme, grubhubLight } from '@grubhubprod/gh-cookbook-react';
import { Square, Squish, Copy } from '@grubhubprod/gh-cookbook-react/dist';
import styled from 'styled-components';
import { Employee } from 'src/components/EmployeeForm/EmployeeForm.utils';

export const HeadingSquare = styled(Square)`
  padding-bottom: 0;
`;

export const EmployeeListSquish = styled(Squish)`
  height: 210px;
  overflow: scroll;
`;

export const EmployeeListItem = styled('div')<{
  isFirst: boolean;
}>`
  padding-top: ${({ isFirst }) =>
    isFirst ? 0 : getSpaceByTheme(grubhubLight, '3')}px;
  padding-bottom: ${getSpaceByTheme(grubhubLight, '3')}px;
  border-bottom: 1px solid ${grubhubLight.colors.lightLine};
`;

export const LinkToCSV = styled(Copy)`
  cursor: pointer;
`;
const employeeHeaderRow = ['First name', 'Last name', 'Email'];

const makeCsv = (rows: string[][]): string =>
  rows.map((row) => row.join(',')).join('\n');

export const createCsvString = (employees: Employee[] = []): string => {
  const employeeRows = employees.map((e) => Object.values(e));

  return makeCsv([employeeHeaderRow, ...employeeRows]);
};

export const createCsvStringWithLocId = (
  employees: Employee[] = [],
  locId: string
): string => {
  const headerRow = [...employeeHeaderRow, 'Group'];
  const employeeRows = employees.map((e) => [
    ...Object.values(e),
    `"${locId}"`,
  ]);

  return makeCsv([headerRow, ...employeeRows]);
};
